import React from "react";
import "./StatsSection.css";

const statsData = [
  { number: "1K+", label: "Active Jobs" },
  { number: "100K+", label: "Candidates" },
  { number: "1K+", label: "Companies" },
  { number: "89%", label: "Success Rate" },
];

const StatsSection = () => {
  return (
    <section className="stats-section">
      <div className="stats-container">
        {statsData.map((stat, index) => (
          <div key={index} className="stat-box">
            <h2>{stat.number}</h2>
            <p>{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsSection;